<p>canvas-editor works!</p>
